"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitToken = splitToken;
function isSellerToken(token) {
    return /^[fjva]_/i.test(token);
}
function isBuyerToken(token) {
    return /^\d+_/i.test(token);
}
function splitToken(token) {
    if (!token) {
        return null;
    }
    const parts = token.split('_');
    // an empty string will still return an array length of 1
    if (parts[0] !== '') {
        if (isSellerToken(token)) {
            return `${parts[0]}_${parts[1]}`;
        }
        else if (isBuyerToken(token)) {
            // need this check otherwise an invalid
            // seller token will be used
            return parts[0];
        }
    }
    return null;
}
//# sourceMappingURL=splitToken.js.map